(function (app, ng) {

    app.config([
        "$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
            $urlRouterProvider.otherwise("/Login");
            $stateProvider.state("Login",
            {
                url: "/Login?{theme}&msg&redirect",
                component: "login",
                PageTitle: "Login", 
                resolve: {
                    logo: [function () {
                        var logo = localStorage.getItem("UserGroupLogo");
                        if (logo === null)
                            return "/Images/figlogo17-full-red.png";
                        return logo;
                    }], 
                    userGroupId: ["$stateParams", function ($stateParams) {
                        if ($stateParams.theme) return $stateParams.theme;
                        var userGroupId = localStorage.getItem("UserGroupId");
                        if (userGroupId) return userGroupId;
                        // if the user hasn't logged in with new auth yet, they won't have a usergroupid in localstorage
                        // but we can grab it from the usergrouplogo
                        var userGroupLogo = localStorage.getItem("UserGroupLogo");
                        if (!userGroupLogo) return null;
                        var userGroupLogoRegex = /\/UserGroups\/(.*)\/Logo/;
                        if (userGroupLogoRegex.test(userGroupLogo))
                            return userGroupLogoRegex.exec(userGroupLogo)[1];
                    }],
                    msg: ["$stateParams", function ($stateParams) { return $stateParams.msg; }],
                    redirect: ["$transition$", function ($transition$) { return $transition$.params().redirect; }]
                }
            });
        }
    ]);

    app.component("login",
    {
        templateUrl: "App/Login/Login.html",
        controller: loginController,
        bindings: {
            logo: "<",
            userGroupId: "<",
            msg: "<",
            redirect: "<"
        }
    });

    loginController.$inject = ["AuthService", "permissionService"];
    function loginController(AuthService, permissionService) {
        var $ctrl = this;

        /*$ctrl.msg = "maintenance";  //uncomment this if portal is under maintenance and it will show maintenance message and not allow redirect to auth.*/

        if (!$ctrl.msg) {
            //added as part of Task 1625: Remove OnBehalfOfUserId on portal timeout
            permissionService.removeStoredOnBehalfOfUserId();
            redirectToLogin();        
        }

        ng.extend($ctrl,
        {
            getThisYear: getThisYear,
            redirectToLogin: redirectToLogin
        });

        function redirectToLogin() {
            $ctrl.isLoggingIn = true;
            AuthService.login($ctrl.userGroupId, $ctrl.redirect);
		}
		
        function getThisYear() {
            var date = new Date();
            return date.getFullYear(); 
        }
    }

})(window.app, window.angular); // jshint ignore:line